/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect } from 'react';
import { setSubProduct } from '@jira/platform__utils-router/src/common/utils/index.tsx';
import { useSubProductForAnalytics } from '@jira/platform__services-subproduct/src/index.tsx';

const SubProductForAnalyticsUpdater = (): null => {
	const subProduct = useSubProductForAnalytics();
	useEffect(() => {
		setSubProduct(subProduct);
	}, [subProduct]);

	return null;
};

export { SubProductForAnalyticsUpdater };
